import { render, staticRenderFns } from "./addReceive.vue?vue&type=template&id=1e790024&scoped=true&"
import script from "./addReceive.vue?vue&type=script&lang=js&"
export * from "./addReceive.vue?vue&type=script&lang=js&"
import style0 from "./addReceive.vue?vue&type=style&index=0&id=1e790024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e790024",
  null
  
)

export default component.exports